<template>
    <div class="row mena-contact-map" v-if="city_title">
        <div class="col-l-4 col-m-4 col-s-12">
            <div class="our-location__label" v-if="city_title">{{ city_title }}</div>
            <div class="location-list">
                <ul>
                    <li
                        class="location-list__item"
                        :class="{'location-list__item--active': activeOffice === i}"
                        v-for="(city, i) in cities"
                        :key="i"
                        @click="setActiveOffice(i, city.city)"
                    >
                        <span class="location-list__item-text">{{ city && city.city }}, {{ city && city.country }}</span>
                        <span v-if="activeOffice === i" class="location-list__item-arrow"></span>
                    </li>
                </ul>
            </div>
        </div>
        <div
            v-if="cities[this.activeOffice]"
            v-html="cities[this.activeOffice].adress"
            class="col-l-4 col-m-4 col-s-12 mena-contact-map__col-1"
        ></div>
        <div
            v-if="cities[this.activeOffice]"
            v-html="cities[this.activeOffice].contact"
            class="col-l-4 col-m-4 col-s-12 mena-contact-map__col-2"
        ></div>
    </div>
</template>

<script>
export default {
    props: ["blockdata", "cities", "city_title"],
    name: "mena-contact-map",
    data() {
        return { activeOffice: 0 };
    },
    mounted: function() {
        this.fetchContactMap();
    },
    methods: {
        fetchContactMap: function() {
            // console.log("cities", this.cities);
        },
        setActiveOffice(officeIndex) {
            this.activeOffice = officeIndex;
        }
    }
};
</script>


// WEBPACK FOOTER //
// MenaContactMap.vue?53019400